import $ from 'jquery';
import Swal from 'sweetalert2';

export function initAiContext() {
    const $pageId = $('#page-id[data-page="ai-context"]');
    if (!$pageId.length) return;

    console.log('[AiContext] Initializing AI Context Registry module');

    const saveUrl = $pageId.data('save-url') || '/ai-context/save';
    const resetUrl = $pageId.data('reset-url') || '/ai-context/reset';
    const bulkDeleteUrl = $pageId.data('bulk-delete-url') || '/ai-context/bulk-delete';

    // Reset Form on modal hide
    $('#modalRegistry').on('hidden.bs.modal', function () {
        $('#formRegistry')[0].reset();
        $('#registry_id').val('');
        $('#formRegistry').attr('action', saveUrl);
        $('#modalRegistryTitle').html('<i class="bi bi-cpu text-primary me-2"></i> Tambah Registry AI Context');
        $('#is_active').prop('checked', true);
    });

    // Form Submit handling with SweetAlert
    $('#formRegistry').on('submit', function (e) {
        e.preventDefault();
        const actionUrl = $(this).attr('action') || saveUrl;

        Swal.fire({
            title: 'Memproses...',
            text: 'Harap tunggu sebentar',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data: $(this).serialize(),
            success: function (response) {
                Swal.close();
                if (response.status === 'success') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil!',
                        text: response.message,
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => {
                        window.location.reload();
                    });
                }
            },
            error: function (xhr) {
                Swal.close();
                let res = xhr.responseJSON;
                let errorMsg = res ? (res.message || 'Terjadi kesalahan') : 'Terjadi kesalahan server';

                // Show errors if validation failed
                if (res && res.errors) {
                    let errs = Object.values(res.errors).join('<br>');
                    errorMsg += '<br><small class="text-danger">' + errs + '</small>';
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Kesalahan!',
                    html: errorMsg
                });
            }
        });
    });

    // Edit Button Click Action
    $(document).on('click', '.btn-edit-registry', function () {
        const id = $(this).data('id');
        const urlJson = $(this).data('url-json');

        Swal.fire({
            title: 'Memuat data...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        $.get(urlJson, function (response) {
            Swal.close();
            if (response.status === 'success') {
                const data = response.data;
                $('#formRegistry').attr('action', saveUrl);
                $('#modalRegistryTitle').html('<i class="bi bi-pencil-square text-primary me-2"></i> Edit Registry AI Context');

                $('#registry_id').val(id);
                $('#purpose_key').val(data.purpose_key);
                $('#title').val(data.title);
                $('#target_table').val(data.target_table);
                $('#limit_rows').val(data.limit_rows);
                $('#select_fields').val(data.select_fields);
                $('#joins').val(data.joins);
                $('#conditions').val(data.conditions);
                $('#is_active').prop('checked', parseInt(data.is_active) === 1);

                $('#modalRegistry').modal('show');
            }
        }).fail(function () {
            Swal.close();
            Swal.fire('Error!', 'Gagal mengambil data dari server.', 'error');
        });
    });

    // Test Run Button Click Action
    $(document).on('click', '.btn-test-registry', function () {
        const urlTest = $(this).data('url-test');

        Swal.fire({
            title: 'Menjalankan Query...',
            text: 'Server sedang mengeksekusi query context & sanitasi data',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        $.get(urlTest, function (response) {
            Swal.close();
            if (response.status === 'success') {
                $('#testResultTitle').text(response.title);
                $('#testResultCount').text(response.count);
                $('#testResultJson').text(JSON.stringify(response.preview, null, 4));
                $('#modalTestResult').modal('show');
            }
        }).fail(function (xhr) {
            Swal.close();
            let res = xhr.responseJSON;
            let errorMsg = res ? (res.message || 'Gagal mengeksekusi query.') : 'Kesalahan koneksi server.';
            Swal.fire({
                icon: 'error',
                title: 'Gagal Eksekusi!',
                text: errorMsg
            });
        });
    });

    // Individual Delete Action
    $(document).on('click', '.btn-delete-submit', function (e) {
        e.preventDefault();
        const form = $(this).closest('form');

        Swal.fire({
            title: 'Apakah Anda yakin?',
            text: 'Registry context ini akan dihapus permanen dari sistem.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Menghapus...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                $.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    data: form.serialize(),
                    success: function (response) {
                        Swal.close();
                        Swal.fire({
                            icon: 'success',
                            title: 'Dihapus!',
                            text: 'Registry berhasil dihapus.',
                            showConfirmButton: false,
                            timer: 1500
                        }).then(() => {
                            window.location.reload();
                        });
                    },
                    error: function (xhr) {
                        Swal.close();
                        Swal.fire('Error!', 'Gagal menghapus data.', 'error');
                    }
                });
            }
        });
    });

    // Checkbox selections for Bulk Delete
    const checkAll = $('#check-all');
    const rowSelects = $('.row-select');
    const btnBulkDelete = $('#btnBulkDelete');
    const selectedCount = $('#selectedCount');

    function updateBulkButton() {
        const checked = $('.row-select:checked');
        selectedCount.text(checked.length);
        if (checked.length > 0) {
            btnBulkDelete.removeClass('d-none');
        } else {
            btnBulkDelete.addClass('d-none');
        }
    }

    checkAll.on('change', function () {
        rowSelects.prop('checked', $(this).is(':checked'));
        updateBulkButton();
    });

    $(document).on('change', '.row-select', function () {
        const allChecked = rowSelects.length === $('.row-select:checked').length;
        checkAll.prop('checked', allChecked);
        updateBulkButton();
    });

    // Bulk Delete Click Action
    btnBulkDelete.on('click', function () {
        const selectedIds = [];
        $('.row-select:checked').each(function () {
            selectedIds.push($(this).val());
        });

        if (selectedIds.length === 0) return;

        Swal.fire({
            title: 'Hapus Semua Terpilih?',
            text: `Anda akan menghapus ${selectedIds.length} registry terpilih secara permanen.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Hapus Semua!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Memproses Hapus Massal...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const postData = {
                    ids: selectedIds
                };

                $.ajax({
                    url: bulkDeleteUrl,
                    type: 'POST',
                    data: postData,
                    success: function (response) {
                        Swal.close();
                        Swal.fire({
                            icon: 'success',
                            title: 'Berhasil!',
                            text: 'Semua registry terpilih berhasil dihapus.',
                            showConfirmButton: false,
                            timer: 1500
                        }).then(() => {
                            window.location.reload();
                        });
                    },
                    error: function (xhr) {
                        Swal.close();
                        Swal.fire('Error!', 'Gagal menghapus data massal.', 'error');
                    }
                });
            }
        });
    });

    // Reset to Default Action
    $('#btnResetDefault').on('click', function () {
        Swal.fire({
            title: 'Setel Ulang ke Default?',
            text: 'Tindakan ini akan mengosongkan seluruh kustomisasi registry saat ini dan mengembalikannya ke pengaturan default bawaan sistem (8 modul utama).',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f0ad4e',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, Setel Ulang!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Mengatur Ulang Registry...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                $.ajax({
                    url: resetUrl,
                    type: 'POST',
                    data: {},
                    success: function (response) {
                        Swal.close();
                        if (response.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: 'Berhasil!',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 1500
                            }).then(() => {
                                window.location.reload();
                            });
                        } else {
                            Swal.fire('Gagal!', response.message || 'Gagal mengatur ulang ke default.', 'error');
                        }
                    },
                    error: function (xhr) {
                        Swal.close();
                        let res = xhr.responseJSON;
                        Swal.fire('Error!', res ? (res.message || 'Gagal reset.') : 'Gagal mengatur ulang ke default.', 'error');
                    }
                });
            }
        });
    });
}
